import { useMemo } from "react";
import { Attribute, ReportAttribute } from "app/api/graph/security-attributes";
import { useGeneralPermissions, Result as GeneralResult } from "app/api/graph/hook/use-general-permissions";
import { useReportOverviewQuery } from "app/api/graph/types";

type Result = GeneralResult & {
    canListUserInvites: boolean;
    canCreateUserInvite: boolean;
    canListUsers: boolean;
    canAddUser: boolean;
    canAddUserFromCompany: boolean;
    canRemoveUser: boolean;
    canCreateReportVulnerability: boolean;
    canCreateReportVersion: boolean;
};

export const useReportPermissions = (permissions: string[] | null | undefined): Result => {
    const generalResult = useGeneralPermissions(permissions);

    return useMemo(
        () => ({
            ...generalResult,
            canListUserInvites: permissions?.includes(ReportAttribute.ViewUserInvites) ?? false,
            canCreateUserInvite: permissions?.includes(ReportAttribute.InviteUser) ?? false,
            canListUsers: permissions?.includes(ReportAttribute.ViewUsers) ?? false,
            canAddUser: permissions?.includes(ReportAttribute.AddUser) ?? false,
            canAddUserFromCompany: permissions?.includes(ReportAttribute.AddCompanyUser) ?? false,
            canRemoveUser: permissions?.includes(ReportAttribute.RemoveUser) ?? false,
            canCreateReportVulnerability: permissions?.includes(ReportAttribute.CreateReportVulnerability) ?? false,
            canCreateReportVersion: permissions?.includes(Attribute.Update) ?? false,
        }),
        [permissions],
    );
};

export const useReportIdPermissions = (reportId: string): Result => {
    const { data } = useReportOverviewQuery({
        variables: { reportId: reportId },
    });

    return useReportPermissions(data?.report?.permissions);
};
